import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.edit.editConfirmation.title',
    defaultMessage: 'CLASS SAVED',
  },
  subtitle: {
    id: 'classesStudents.edit.editConfirmation.subtitle',
    defaultMessage: 'Class was successfully saved.',
  },
  continue: {
    id: 'classesStudents.edit.editConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
